import { z } from 'zod';

export const BootupSchema = z.object({
  minVersion: z.number(),
});
export type BootupData = z.infer<typeof BootupSchema>;
